import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: Review → /cases
export const Route = createFileRoute("/review")({
  beforeLoad: () => {
    throw redirect({ to: "/cases", replace: true });
  },
  component: () => null,
});
